import React from 'react';
import PropTypes from 'prop-types';
import { isString } from 'lodash';
import clxBind from 'classnames/bind';
import Link from '../Link';
import Icon from '../Icon';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class MenuItem extends React.Component {
  static propTypes = {
    LinkComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    visible: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    contentClassName: PropTypes.string,
  };

  static defaultProps = {
    LinkComponent: Link,
    icon: undefined,
    visible: true,
    children: null,
    className: undefined,
    contentClassName: undefined,
  };

  renderIcon() {
    const { icon } = this.props;

    return isString(icon) ? <Icon icon={icon} className={styles['icon']} /> : icon;
  }

  renderContent() {
    const { children, contentClassName } = this.props;

    return (
      children && (
        <div className={clx(contentClassName, 'content')}>
          <div className={styles['inner']}>{children}</div>
        </div>
      )
    );
  }

  render() {
    const { LinkComponent, icon, visible, className, contentClassName, ...props } = this.props;

    if (!visible) {
      return null;
    }

    const itemClasses = clx('item', className);

    return (
      <LinkComponent className={itemClasses} {...props}>
        {this.renderIcon()}
        {this.renderContent()}
      </LinkComponent>
    );
  }
}
